module.exports = __webpack_public_path__ + "img/travel-banner.bee28f96.jpg";